import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { IComponentOptionsProperties } from '../interfaces/IComponentOptionsProperties.interface';

@Injectable({
    providedIn: 'root',
})
export class ComponentOptionsHelper {
    // Form value outputs for example : staticFields{text:'english text', Inhalt:'german text'}
    // We use this mapper to change that to : {text: {'en-us':'english text, 'de-ch':'german text'}}

    static mapFormValueTranslationsAndCombineFields(
        formFields: IComponentOptionsProperties,
        staticFields: IComponentOptionsProperties,
        dynamicFields: IComponentOptionsProperties,
        form: UntypedFormGroup,
    ) {
        let mappedFormValue = {};
        if (staticFields.properties.length) {
            staticFields.properties.forEach((staticFieldData) => {
                const outputValue = this.getStaticFieldOutputValue(staticFieldData, form);

                // to get output object key which is the identifier regardless of the language of the property
                const property = formFields.properties.find((field) => field.identifier === staticFieldData.identifier);
                mappedFormValue[property.identifier] = outputValue;
            });
        }

        if (dynamicFields.properties.length) {
            dynamicFields.properties.forEach((fieldData) => {
                mappedFormValue = this.getDynamicFormArrayOutputValue(fieldData, mappedFormValue, form, formFields);
            });
        }
        return mappedFormValue;
    }

    static getStaticFieldOutputValue(fieldData, form: UntypedFormGroup) {
        let outputValue = {};
        // matching each form value field to its correct language value
        if (fieldData.toggle) {
            // Because toggle has only a property of type string and not array of languages
            outputValue = form.value.staticFields[fieldData.property];
        } else {
            Object.keys(fieldData.property).forEach((language) => {
                const value = form.value.staticFields[fieldData.property[language]];
                if (value) {
                    outputValue[language] = value;
                }
            });
        }

        return outputValue;
    }

    // Getting a single object in the array of dynamic field values.
    static getDynamicFieldOutputValue(fieldData, Formfield) {
        const outputValue = {};
        // matching each form value field to its correct language
        Object.keys(fieldData.property).forEach((language) => {
            if (Formfield.hasOwnProperty(fieldData.property[language])) {
                const value = Formfield[fieldData.property[language]];
                outputValue[language] = value;
            }
        });
        return outputValue;
    }

    // Getting array of dynamic fields values
    static getDynamicFormArrayOutputValue(
        fieldData,
        mappedFormValue,
        form: UntypedFormGroup,
        formFields: IComponentOptionsProperties,
    ) {
        const valueArray = [];
        form.value.dynamicFields.forEach((Formfield) => {
            const outputValue = this.getDynamicFieldOutputValue(fieldData, Formfield);
            valueArray.push(outputValue);
            // to get output object key which is the identifier regardless of the language of the property
            const property = formFields.properties.find((field) => field.identifier === fieldData.identifier);
            mappedFormValue[property.identifier] = valueArray;
        });
        return mappedFormValue;
    }
}
